import type { MutableRefObject } from 'react';
import { LIVE_VOICE_FUNCTION_LIMITS } from './live-voice-function-calls';

type OperationContext = {
  activeOperationRef: MutableRefObject<string | null>;
  claimedOperationsRef: MutableRefObject<Set<string>>;
};

/**
 * One effect per operation kind in a hosted delegation, including continuations.
 * Provider call IDs separately deduplicate retransmissions. Delegation IDs do
 * not identify spoken utterances; transcript fragments never rearm this claim.
 */
export function claimLiveVoiceToolOperation(
  context: OperationContext,
  kind:
    | 'delegation'
    | 'web_search'
    | 'quick_research'
    | 'questionnaire'
    | 'navigation'
    | 'chat_send'
): boolean {
  const operationId = context.activeOperationRef.current;
  if (!operationId) return false;
  const key = JSON.stringify([operationId, kind]);
  const claims = context.claimedOperationsRef.current;
  const competingKind =
    kind === 'delegation'
      ? 'chat_send'
      : kind === 'chat_send'
        ? 'delegation'
        : null;
  if (
    claims.has(key) ||
    (competingKind !== null &&
      claims.has(JSON.stringify([operationId, competingKind]))) ||
    claims.size >= LIVE_VOICE_FUNCTION_LIMITS.delegations * 6
  )
    return false;
  // Claim before effects. An ambiguous failure cannot automatically repeat work.
  claims.add(key);
  return true;
}
